import type { JobAppointment } from '@/types/jobAppointment';

const LIVE_VISIT_STATUSES = new Set([
  'RESERVED',
  'SCHEDULED',
  'CONFIRMED',
  'DISPATCHED',
  'IN_PROGRESS',
  'ON_HOLD',
]);

/** Mirrors the server rule for showing job-wide Hold to a scoped editor. */
export function canHoldJob(
  editScope: string | null,
  technicianId: string | null,
  visits: readonly JobAppointment[],
): boolean {
  if (editScope === 'ALL' || (!technicianId && (editScope === 'OWN' || editScope === 'TEAM'))) return true;
  if (!editScope || !technicianId) return false;

  return visits.some((visit) => {
    if (!LIVE_VISIT_STATUSES.has(visit.status)) return false;
    if (visit.technicians.length > 0) {
      return visit.technicians.some(
        (member) => member.id === technicianId && member.role === 'LEAD',
      );
    }
    return visit.primaryTechnician?.id === technicianId;
  });
}

/** Cancelled visits retain their crew, so a former lead may restore the job. */
export function canRestoreJob(
  editScope: string | null,
  technicianId: string | null,
  visits: readonly JobAppointment[],
): boolean {
  if (editScope === 'ALL') return true;
  if (!editScope || !technicianId) return false;

  return visits.some((visit) => {
    if (visit.status !== 'CANCELLED') return false;
    if (visit.technicians.length > 0) {
      return visit.technicians.some(
        (member) => member.id === technicianId && member.role === 'LEAD',
      );
    }
    return visit.primaryTechnician?.id === technicianId;
  });
}
